angular.module('mtic.components.modules.c3')
.service('runLikeMathItemFactory', function(
  C3_ASSET_URL,
  EventManager,
  $log,
  $timeout,
  TIMING_CONSTANTS,
  language,
  TeacherDataService
) {
    var eventManager = new EventManager("runLikeMathItemFactory");
    var currentActiveItem = null;
    var getIconTexture = function(count,subModuleSprite){
      var starIcon;
      var starsSprite = PIXI.BaseTexture.fromImage(C3_ASSET_URL + "stars.png");
      var spriteTexture ;
      if(count)
      {
        spriteTexture = new PIXI.Texture(starsSprite, new PIXI.Rectangle(count*90, 0, 90,49));
        starIcon = new PIXI.Sprite(spriteTexture);
        starIcon.position.x = subModuleSprite.position.x-20;
        starIcon.position.y = subModuleSprite.position.y-(subModuleSprite.height/2);
      }

      return starIcon;
    }

    var getStars = function(item_info){
      var levelData = {};
      var score = item_info.resourceState.score_max;
      if (score >= 1) 
      {
          levelData.starsAchieved = 3;
          levelData.badged = true;
      } 
      else if (score >= 0.75) {  levelData.starsAchieved = 3;}
      else if (score >= 0.5)  {  levelData.starsAchieved = 2;}
      else if (score >= 0.25) {  levelData.starsAchieved = 1;}
      
      return levelData;
    }
    
    return {
      getCurrentActiveItem: function() {
        return currentActiveItem;
      },
      createMapItem: function MapItem(item_info,onItemClick,positioningParams,count,stage) {

        // Grab Relevant data for item
        this.resource_info = item_info;
        this.slug = item_info.slug;
        this.type = item_info.resource_type;
        this.studentWork = item_info.studentWork;
        this.container = item_info.content.container;
        this.complete = item_info.complete;
        this.locked = item_info.locked;
        this.unlocked_by = item_info.unlocked_by;
        this.content = item_info.content;
        this.verletBody = null;
        this.parentItem = null;
        var sprite, icon,agenda_highlight=null;
        var startClickPos = {
          x: 0,
          y: 0
        };
        var buttonImage = PIXI.BaseTexture.fromImage(C3_ASSET_URL + "numpadBtn_orange.png");
        var buttonTexture = new PIXI.Texture(buttonImage, new PIXI.Rectangle(0, 110, 135,100));
        sprite = new PIXI.Sprite(buttonTexture);
        sprite.width = 90;
        sprite.height = 100;
        var colIndex = count%positioningParams.maxPerRow;
        if(colIndex ===0){
          sprite.position.x = positioningParams.paddingLeft;
        }else{
          sprite.position.x = positioningParams.paddingLeft +(colIndex * (positioningParams.width+positioningParams.paddingBetweenItem));
        }

        var rowIndex = Math.floor(count /positioningParams.maxPerRow);
        if(rowIndex===0){
          sprite.position.y = positioningParams.paddingTop;
        }else{
          sprite.position.y = positioningParams.paddingTop + (rowIndex * (positioningParams.height+positioningParams.paddingBetweenItem));
        }
        
        var textInfo;
        this.setupText = function(count,sprite){
          // Text Information
          textInfo = new PIXI.Text(count+1);
          textInfo.style.align = "center";
          textInfo.style.fill = "white";
          textInfo.style.fontFamily = "vanilla-extract-edit";
          textInfo.style.fontSize = 50;
          textInfo.style.fontWeight = 'bold';
          textInfo.position.set(sprite.position.x+(sprite.width-textInfo.width)/2,sprite.position.y+(sprite.height-textInfo.height)/2);
          stage.addChild(textInfo);
        }

        this.clearText = function(){
            textInfo.setText("");
            textInfo.updateText();
        }

        this.updateText = function(val){
          textInfo.setText(val);
          textInfo.updateText();
        }

        this.getItemInfo = function() {
          return item_info;
        }

        this.setItemComplete = function() {
          if (this.studentWork) {
            this.studentWork.completions++;
          } else {
            this.studentWork = {
              completions: 1,
            };
          }
        }

        this.selectStar = function(texture){
          this.icon.texture =  texture;
        }

        this.icon = new PIXI.Sprite();
        sprite.addChild(this.icon);
        this.sprite = sprite;
      }
    }
  });
